<template>
  <div class="wrapper">
    <!-- 全屏刷新loading遮罩 -->
    <div v-if="reloadLoading" class="reload-loading-mask">
      <div class="reload-loading-content">
        <i class="el-icon-loading"></i>
        <p>正在切换公司，请稍候...</p>
      </div>
    </div>
    
    <div class="user-info" style="display: flex">
      <!-- <div class="avatar-box" @click="goToUserInfo">
        <img class="avatar" :src="user_pic" />
      </div> -->
      <div class="user-name" style="color: #fff">
        <p>{{ tenant_name  }}</p>
      </div>
      <div class="change-icon">
        <img src="@/assets/icons/change.png" @click="showCompanyDialog" />
      </div>
    </div>

    <!-- 切换公司弹框 -->
    <el-dialog
      title="请选择您登录的公司"
      :visible.sync="companyDialogVisible"
      width="500px"
      left
      append-to-body
      modal-append-to-body
      @close="handleDialogClose"
    >
      <div class="company-list">
        <div
          class="company-item"
          v-for="item in companyoptions"
          :key="item.key"
          :class="{ active: selectedCompany === item.key }"
          @click="handleSelectCompany(item.key)"
        >
          {{ item.name }}
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="companyDialogVisible = false" :disabled="loading">取消</el-button>
        <el-button
          type="primary"
          @click="confirmChangeCompany"
          :disabled="!selectedCompany || loading"
          :loading="loading"
        >
          确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Post } from '../../js/http.js'
import { getFromLocal } from '../../js/tool.js'

export default {
  data() {
    return {
      companyDialogVisible: false, // 控制弹框显示
      selectedCompany: '', // 当前选中的公司ID
      companyoptions: [], // 公司列表数据
      loading: false, // 加载状态
      reloadLoading: false // 刷新页面loading状态
    }
  },
  computed: {
   tenant_name  () {
      const localValue = localStorage.getItem('companyName');
      const storeValue = this.$store.state.tenant_name;
      console.log('tenant_name 计算属性 - localValue:', localValue, 'storeValue:', storeValue);
      return localValue || storeValue;
    },

    user_pic () {
      const localValue = localStorage.getItem('user_pic');
      const storeValue = this.$store.state.user_pic;
      console.log('user_pic 计算属性 - localValue:', localValue, 'storeValue:', storeValue);
      // 检查 localValue 和 storeValue 是否存在且不为空
      if (localValue && localValue !== 'null' && localValue !== 'undefined') {
        return localValue;
      } else if (storeValue && storeValue !== null && storeValue !== 'null' && storeValue !== 'undefined') {
        return storeValue;
      } else {
        // 没有头像时返回默认头像
        return require('@/assets/header.png');
      }
    }
  },
  mounted() {
    // 初始化时获取公司信息和头像
    this.getCompanyInfo();
  },
  methods: {
    // 获取公司信息和头像
    async getCompanyInfo() {
      const version = '1.0';
      // 从localStorage获取token
      const token = getFromLocal('token');

      if (!token) {
        console.log('没有token，无法获取公司信息');
        // 没有token时使用默认头像
        const defaultImage = require('@/assets/header.png');
        this.$store.commit('user_pic', defaultImage);
        return;
      }

      this.loading = true;
      try {
        console.log('开始获取公司信息...');
        // 获取公司信息
        try {
          const infoRes = await Get(`api/v${version}/customers/info`);
          console.log('获取公司信息响应:', infoRes);
          if (infoRes.isSuccess && infoRes.data) {
            const companyInfo = infoRes.data;
            console.log('公司信息:', companyInfo);
            // 更新store中的公司名称
            this.$store.commit('tenant_name', companyInfo.customerName);
            // 同时更新localStorage中的companyName
            localStorage.setItem('companyName', companyInfo.customerName);
            console.log('公司名称已更新到store和localStorage');
          }
        } catch (infoErr) {
          console.error('获取公司信息失败:', infoErr);
          // 公司信息获取失败不影响头像获取，不显示错误提示
        }

        console.log('开始获取公司头像...');
        // 获取公司头像
        try {
          const logoRes = await Get(`api/v1/customers/logo`);
          console.log('获取公司头像响应:', logoRes);
          if (logoRes.isSuccess && logoRes.data) {
            // 接口返回的 data 已经是 base64 字符串
            const logoData = `data:${logoRes.msg};base64,${logoRes.data}`;
            console.log('公司头像数据:', logoData.substring(0, 50) + '...');
            // 存储到Vuex store，更新顶部logo
            this.$store.commit('user_pic', logoData);
            // 同时更新 localStorage，确保导航栏的头像立即更新
            localStorage.setItem('user_pic', logoData);
            console.log('公司头像已更新到store和localStorage');
          } else {
            // 没有头像，使用默认图片
            const defaultImage = require('@/assets/header.png');
            this.$store.commit('user_pic', defaultImage);
            // 同时更新 localStorage，确保导航栏的头像立即更新
            localStorage.setItem('user_pic', defaultImage);
            console.log('使用默认头像');
          }
        } catch (logoErr) {
          console.error('获取公司头像失败:', logoErr);
          // 出错时使用默认图片，不显示错误提示
          const defaultImage = require('@/assets/header.png');
          this.$store.commit('user_pic', defaultImage);
          // 同时更新 localStorage，确保导航栏的头像立即更新
          localStorage.setItem('user_pic', defaultImage);
          console.log('使用默认头像');
        }
      } catch (err) {
        console.error('获取公司信息或头像失败:', err);
        // 出错时使用默认图片，不显示错误提示
        const defaultImage = require('@/assets/header.png');
        this.$store.commit('user_pic', defaultImage);
        // 同时更新 localStorage，确保导航栏的头像立即更新
        localStorage.setItem('user_pic', defaultImage);
        console.log('使用默认头像');
      } finally {
        this.loading = false;
      }
    },
    // 显示切换公司弹框
    showCompanyDialog () {
      // 从接口获取公司列表数据
      this.getCompanySelectors()
    },

    // 获取公司选择器数据
    getCompanySelectors () {
      const version = '1.0'
      // 从localStorage获取token
      const token = getFromLocal('token')

      if (!token) {
        this.$message.error('请先登录')
        return
      }

      Get(`api/v${version}/customers/selectors`, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
        .then(res => {
          console.log('公司选择器数据:', res)
          if (res.isSuccess && res.data) {
            // 保存公司列表数据
            this.companyoptions = res.data || []
            // 获取默认公司信息
            this.getDefaultCompanyInfo()
          } else {
            this.$message.error(res.msg || '获取公司列表失败')
          }
        })
        .catch(err => {
          console.error('获取公司选择器失败:', err)
          this.$message.error(err.msg || err.message || '获取公司列表失败')
        })
    },

    // 获取默认公司信息
    getDefaultCompanyInfo () {
      const version = '1.0'
      // 从localStorage获取token
      const token = getFromLocal('token')

      if (!token) {
        this.$message.error('请先登录')
        return
      }

      Get(`api/v${version}/customers/info`, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
        .then(res => {
          console.log('默认公司信息:', res)
          if (res.isSuccess && res.data) {
            const defaultCompanyInfo = res.data
            // 根据默认公司信息设置选中状态
            this.setDefaultSelectedCompany(defaultCompanyInfo)
            // 显示公司选择弹框
            this.companyDialogVisible = true
          } else {
            this.setDefaultSelectedFirstCompany()
            // 显示公司选择弹框
            this.companyDialogVisible = true
          }
        })
        .catch(err => {
          console.error('获取默认公司信息失败:', err)
          console.warn('获取默认公司信息失败，默认选中第一条数据')
          // 获取默认公司信息失败，默认选中第一条数据
          this.setDefaultSelectedFirstCompany()
          // 显示公司选择弹框
          this.companyDialogVisible = true
        })
    },

    // 根据默认公司信息设置选中状态
    setDefaultSelectedCompany (defaultCompanyInfo) {
      if (defaultCompanyInfo) {
        console.log('根据默认公司信息设置选中状态:', defaultCompanyInfo)
        // 尝试使用不同的字段查找公司
        const companyId = defaultCompanyInfo.tenantId || defaultCompanyInfo.id || defaultCompanyInfo.customerId
        if (companyId) {
          console.log('查找公司ID:', companyId)
          // 在公司列表中查找默认公司
          const defaultCompany = this.companyoptions.find(
            company => company.key === companyId
          )

          if (defaultCompany) {
            // 找到默认公司，设置选中状态
            this.selectedCompany = defaultCompany.key
            console.log('选中的默认公司:', defaultCompany)
          } else {
            // 未找到默认公司，默认选中第一条数据
            this.setDefaultSelectedFirstCompany()
          }
        } else {
          // 没有找到公司ID，默认选中第一条数据
          this.setDefaultSelectedFirstCompany()
        }
      } else {
        // 默认公司信息不完整，默认选中第一条数据
        this.setDefaultSelectedFirstCompany()
      }
    },

    // 默认选中第一条数据
    setDefaultSelectedFirstCompany () {
      if (this.companyoptions && this.companyoptions.length > 0) {
        console.log('默认选中第一条数据:', this.companyoptions[0])
        // 确保数据格式正确
        if (this.companyoptions[0].key) {
          this.selectedCompany = this.companyoptions[0].key
        }
      }
    },

    // 选择公司
    handleSelectCompany (key) {
      console.log('选择的公司key:', key)
      this.selectedCompany = key
    },

    // 确认切换公司
    confirmChangeCompany () {
      console.log('确认切换公司，选中的key:', this.selectedCompany)
      if (!this.selectedCompany) {
        this.$message.warning('请选择要切换的公司')
        return
      }

      // 获取选中的公司信息
      const selectedCompany = this.companyoptions.find(
        company => company.key === this.selectedCompany
      )

      if (selectedCompany) {
        console.log('切换到公司:', selectedCompany)
        this.$message.success(`已切换到 ${selectedCompany.name}`)
        this.companyDialogVisible = false

        // 调用选择租户接口
        this.selectTenant(selectedCompany.key)
      }
    },

    // 调用选择租户接口
    selectTenant (tenantId) {
      const version = '1.0'
      // 从localStorage获取token
      const token = localStorage.getItem('token')
      if (!token) {
        this.$message.error('请先登录')
        return
      }
      
      this.loading = true
      Post(
        `api/v${version}/accounts/me/tenant/switch-tenant`,
        {},
        {
          selectedTenantId: tenantId
        },
        {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }
      )
        .then(res => {
          console.log('切换租户响应:', res)
          if (res.isSuccess && res.data) {
            // 切换租户成功，更新本地存储的用户信息和token
            const data = res.data
            
            // 检查是否返回了新的token
            if (data.token) {
              localStorage.setItem('token', data.token)
              console.log('Token updated successfully:', data.token)
            }
            
            // 获取当前用户名
            const currentUserName = localStorage.getItem('user_name');
            
            // 更新客服信息
            if (data.supportStaffName) {
              localStorage.setItem('server_name', data.supportStaffName)
              localStorage.setItem('server_phone', data.supportStaffPhone || '')
              localStorage.setItem('server_mobilephone', data.supportStaffMobilePhone || '')
              localStorage.setItem('server_email', data.supportStaffEmail || '')
              
              // 更新store中的客服信息
              this.$store.commit('login', {
                user_name: currentUserName,
                server_name: data.supportStaffName,
                server_phone: data.supportStaffPhone || '',
                server_mobilephone: data.supportStaffMobilePhone || '',
                server_email: data.supportStaffEmail || ''
              })
            }
            
            // 更新租户信息
            if (data.selectedTenantId) {
              localStorage.setItem('tenant_id', data.selectedTenantId)
              localStorage.setItem('companyName', data.selectedTenantName || '')
              this.$store.commit('login', {
                user_name: currentUserName,
                tenant_id: data.selectedTenantId,
                tenant_name: data.selectedTenantName || ''
              })
            }
            
            // 可以触发事件通知父组件
            this.$emit('company-changed', data)
            // 显示刷新loading并刷新当前页面
            this.reloadLoading = true
            console.log('切换租户成功，刷新当前页面')
            // 刷新当前页面，保持在当前路由
            location.reload()
          } else {
            this.$message.error(res.msg || '切换租户失败')
            this.loading = false
          }
        })
        .catch(err => {
          console.error('切换租户错误:', err)
          this.$message.error(err.msg || err.message || '切换租户失败')
          this.loading = false
        }
      )
    },

    // 对话框关闭时的处理
    handleDialogClose () {
      this.selectedCompany = ''
    },
    // 跳转到用户信息页面
    goToUserInfo () {
      this.$router.push({ name: 'UserInfo' })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__header {
  margin-bottom: 20px;
  color: #303133 !important;
  border-bottom: 1px solid #dcdfeb;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.wrapper {
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 14px;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar-box {
  overflow: hidden;
  width: 36px;
  height: 36px;
  margin-right: 13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  cursor: pointer;

  .avatar {
    width: 36px;
    height: 36px;
  }
}

.change-icon {
  margin-left: 10px;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }
}

.user-name {
  font-size: 16px;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
}

/* 公司列表样式 */
.company-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
}

.company-item {
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f9f9f9;
}

.company-item:hover {
  border-color: #4c80fa;
  color: #4c80fa;
}

.company-item.active {
  border-color: #4c80fa;
  color: #4c80fa;
}

/* 对话框底部样式 */
.dialog-footer {
  text-align: center;
}

/* 全屏刷新loading遮罩 */
.reload-loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reload-loading-content {
  text-align: center;
  color: #fff;
  background-color: rgba(50, 50, 50, 0.9);
  padding: 40px 60px;
  border-radius: 10px;
}

.reload-loading-content .el-icon-loading {
  font-size: 48px;
  margin-bottom: 20px;
}

.reload-loading-content p {
  font-size: 18px;
  margin-top: 10px;
}
</style>
